import React from 'react';
import PropTypes from 'prop-types';
import FloatingLabel from 'Components/UI/BehavioralFormElement/LabelDecorator/Floating';
import Email from 'Components/UI/BehavioralFormElement/NormalizedInput/Email';
import { validateEmail } from 'Helpers/Validation';
import { noop } from 'Helpers/PropTypes';

const EmailInputAlias = ({
  className, label, test, ...props
}) => {
  const { value } = props;
  const isEmailValid = validateEmail(value);
  const isValidClass = !isEmailValid ? 'invalid' : null;
  return (
    <FloatingLabel
      className={`Input ${className} ${isValidClass}`}
      label={label}
      test={test}
    >
      <Email {...props} />
    </FloatingLabel>
  );
};

EmailInputAlias.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  test: PropTypes.string,
};

EmailInputAlias.defaultProps = {
  className: '',
  label: '',
  onKeyDown: noop,
  placeholder: '',
  value: '',
  test: '',
};

export default EmailInputAlias;
